import { render } from "./DashboardCA.vue?vue&type=template&id=3c8d7f70"
import script from "./DashboardCA.vue?vue&type=script&lang=js"
export * from "./DashboardCA.vue?vue&type=script&lang=js"

import "./DashboardCA.vue?vue&type=style&index=0&id=3c8d7f70&lang=css"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__